import React, { useEffect, useState } from "react";
import "../index.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
};

const labels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

const FactoryWeight = ({ stat, valueA, valueB, charts, charts2, stats2 }) => {
  const data = {
    labels,
    credits: {
      enabled: false,
    },
    datasets: [
      {
        label: "Center",
        data: charts?.map((stat) => stat.weight),
        backgroundColor: "#c4da00",
      },
      {
        label: "Factory",
        data: charts2?.map((stat) => stat.weight),
        backgroundColor: "#404040",
      },
    ],
  };

  return (
    <div className="cardss">
      <div className="requestFlex">
        <div className="d-flex align-items-center">
          <div className="dropOff_image">
            <img src={stat} alt="stat" />
          </div>
          <h4 className="dropOff__title mt-1">
            Total Weight at Center vs Factory
          </h4>
        </div>
      </div>
      <div>
        {/* <div className="mt-0 mb-2">
          <div className="d-flex ml-2">
            <div className="d-flex align-items-center">
              <div className="box green"></div>
              <p className="mb-0 ml-2">Center</p>
            </div>
            <div className="d-flex align-items-center ml-4">
              <div className="box dark"></div>
              <p className="mb-0 ml-2">Factory</p>
            </div>
          </div>
        </div> */}

        <div className="my-2 d-flex align-items-center justify-content-center">
          <div className="d-flex align-items-center justify-content-center thisMonth">
            <p className="mb-0">This month: </p>
            <h6
              className="mb-0"
              style={{
                color: "#c4da00",
                fontWeight: "bold",
                marginLeft: "10px",
              }}
            >
              {Math.round(
                (stats2.total_requests_count + Number.EPSILON) * 100
              ) / 100}{" "}
              KG
            </h6>
          </div>
        </div>
        <div className="ml-3 pb-1 chartImg">
          {/* <img src={chart} alt="chart" /> */}
          <Bar options={options} data={data} />
        </div>
      </div>
    </div>
  );
};

export default FactoryWeight;
